(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vf-pattern-spotlight"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const timeZone = 'America/Los_Angeles';

    const getDayNumber = () => {
      const parts = new Intl.DateTimeFormat('en-US', {
        timeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }).formatToParts(new Date());
      const values = {};
      parts.forEach((part) => {
        if (part.type !== 'literal') values[part.type] = Number(part.value);
      });
      return Math.floor(Date.UTC(values.year, values.month - 1, values.day) / 86400000);
    };

    const initializeSpotlight = (section) => {
      if (!section || section.dataset.vfSpotlightReady === 'true') return;

      const dataElement = section.querySelector('[data-vf-pattern-data]');
      if (!dataElement) return;

      let candidates = [];
      try {
        candidates = JSON.parse(dataElement.textContent);
      } catch (error) {
        section.hidden = true;
        return;
      }

      const uniqueCandidates = Array.from(
        new Map(candidates.map((candidate) => [String(candidate.id), candidate])).values()
      );

      if (uniqueCandidates.length === 0) {
        section.hidden = true;
        return;
      }

      const image = section.querySelector('.vf-pattern-spotlight__image');
      const title = section.querySelector('[data-vf-pattern-title]');
      const description = section.querySelector('[data-vf-pattern-description]');
      const category = section.querySelector('[data-vf-pattern-category]');
      const link = section.querySelector('[data-vf-pattern-link]');

      const render = () => {
        const candidate = uniqueCandidates[getDayNumber() % uniqueCandidates.length];
        if (!candidate) return;

        if (image) {
          image.src = candidate.image.src;
          image.srcset = candidate.image.srcset;
          image.alt = candidate.image.alt;
        }
        if (title) title.textContent = candidate.title;
        if (description) description.textContent = candidate.description;
        if (category) category.textContent = candidate.category;
        if (link) {
          link.href = candidate.url;
          link.textContent = candidate.buttonLabel;
        }
        section.hidden = false;
      };

      render();
      section.dataset.vfSpotlightReady = 'true';
      section.vfSpotlightTimer = window.setInterval(render, 60000);
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-vf-pattern-spotlight]').forEach(initializeSpotlight);
    };

    initializeAll();

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      const section = event.target.querySelector('[data-vf-pattern-spotlight]');
      if (section && section.vfSpotlightTimer) window.clearInterval(section.vfSpotlightTimer);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
